"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
/**
 * tworzy funkcję obliczającą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
function calcFunction(schema, cache, debug, useStrict) {
    if (cache === void 0) { cache = true; }
    var func = null;
    var calc = schema.calc;
    if (calc) {
        if (schema._calcFunc) {
            return schema._calcFunc;
        }
        var funcText = schema.calc;
        // const cacheKey = funcText;
        var when = '';
        var ftext = '';
        var stext = '';
        if (calc.func) {
            funcText = calc.func;
            when = calc.when;
        }
        var cacheKey = '';
        if (cache && !debug) {
            cacheKey = 'calc'
                + (when ? "||when:" + when : '')
                + ("||type:" + schema.type)
                + (schema.precision ? "||prec:" + schema.precision : '')
                + ("||text:" + funcText);
            func = cacheFuncs[cacheKey];
            if (func !== undefined) {
                Object.defineProperty(schema, '_calcFunc', {
                    value: func
                });
                return func;
            }
        }
        if (Array.isArray(funcText)) {
            funcText = funcText.join('\r\n');
            // jednak nie zamieniam return, przyda się do undefined
            /*
                  if (funcText.indexOf("return ") === -1) {
                      funcText = "var $result;\r\n" + funcText;
      
                  } else {
                      funcText = funcText.replace("return ", "var $result = ");
                  }
                  */
            funcText = 'var $result;\r\n' + funcText;
            stext = fix_parent_1.default(funcText);
            ftext = stext + '\r\n';
            stext = '$result';
        }
        else {
            stext = fix_parent_1.default(funcText);
            if (debug) {
                ftext += "var $result = (" + stext + ");\r\n";
            }
        }
        if (debug) {
            // ftext += `var result = (${stext});\r\n`;
            switch (schema.type) {
                case 'integer':
                    ftext += '/*** round to integer ***/\r\n';
                    ftext += "$result = $methods.mround($result,0);\r\n";
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    if (schema.precision !== undefined) {
                        ftext += '/*** round to ' + schema.precision + ' digits ***/\r\n';
                        ftext += "$result = $methods.mround($result," + schema.precision + ");\r\n";
                    }
                    else {
                        ftext += '/*** round to money ***/\r\n';
                        ftext += "$result = $methods.mround($result,2);\r\n";
                    }
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext += '/*** round to ' + schema.precision + ' digits ***/\r\n';
                        ftext += "$result = $methods.mround($result," + schema.precision + ");\r\n";
                    }
                    else {
                        // ftext += `return result;`;
                    }
                    break;
                case 'object':
                    // deep copy, żeby reagował na kazdą zmianę pola
                    ftext += '/*** deep copy to object ***/\r\n';
                    // ftext += `$result = $methods.deepCopy($result);\r\n`;
                    var keys = Object.keys(schema.properties || {});
                    ftext += '$result = !$result ? null : {' + keys.map(function (x) { return ((schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object') ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')' : x + ': $result.' + x; }).join(', ') + '}';
                    ftext += '\r\n';
                    break;
                default:
                    // ftext += `return result;`;
                    break;
            }
            if (when) {
                ftext = "if (" + fix_parent_1.default(when) + ") { // when: " + when + "\r\n\r\n" + ftext + "return $result;\r\n\r\n}";
            }
            else {
                ftext += 'return $result;';
            }
            // schemaPath
            // ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
            ftext = "\r\n/*** " + schemaPath_1.default(schema, true) + " calc debug ***/\r\nconsole.debug('calc: '+$obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n" + ftext;
            // ftext = `"${schemaPath(schema, true)}";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n${ftext}`;
            // ftext = '"' + schemaPath(schema, true) + '";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        else {
            switch (schema.type) {
                case 'integer':
                    ftext += "return $methods.mround((" + stext + "),0);\r\n";
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    if (schema.precision !== undefined) {
                        ftext += "return $methods.mround((" + stext + ")," + schema.precision + ");\r\n";
                    }
                    else {
                        ftext += "return $methods.mround((" + stext + "),2);\r\n";
                    }
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext += "return $methods.mround((" + stext + ")," + schema.precision + ");\r\n";
                    }
                    else {
                        ftext += "return (" + stext + ");";
                    }
                    break;
                case 'object':
                    // deep copy, żeby reagował na kazdą zmianę pola
                    // ftext += `return $methods.deepCopy(${stext});`;
                    var keys = Object.keys(schema.properties || {});
                    ftext += 'var $result=(' + stext + '); return !$result ? null : {' + keys.map(function (x) { return ((schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object') ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')' : x + ': $result.' + x; }).join(', ') + '}';
                    break;
                default:
                    ftext += "return (" + stext + ");";
                    break;
            }
            if (when) {
                ftext = "if (" + fix_parent_1.default(when) + ") {\r\n  " + ftext + "}";
            }
        }
        if (useStrict || process.env.NODE_ENV !== 'production') {
            ftext = '"use strict";\r\n' + ftext;
        }
        func = new Function(funcParams_1.default, ftext);
        if (cacheKey) {
            cacheFuncs[cacheKey] = func;
            Object.defineProperty(schema, '_calcFunc', {
                value: func
            });
        }
    }
    return func;
}
exports.default = calcFunction;
//# sourceMappingURL=calcFunction.js.map